import { services } from "../services";
import { DBFile } from "@iibf/shared-resources/models/db";

export const uploadFile = (file: File) => {
  const formData = new FormData();
  formData.append("file", file as any);
  console.log("File ", file);
  return services.requestSvc.post<DBFile>("/upload-file", formData);
};
